import { supabase } from '@/integrations/supabase/client';

export interface WikipediaData {
  title: string;
  extract: string;
  images: string[];
  url: string;
}

export const wikipediaService = async (query: string): Promise<WikipediaData | null> => {
  try {
    const { data, error } = await supabase.functions.invoke('runAgent', {
      body: { agent: 'wikipedia', query }
    });
    
    if (error || !data || data.error) {
      return null;
    }
    
    return data;
  } catch (error) {
    console.error('Wikipedia API error:', error);
    return null;
  }
};
